<template>
  <admin-layout>
    <div id="post-details" class="root">
      <div class="row">
        <div class="col-lg-12">
          <h5>
            <router-link to="/a/posts" class="btn btn-primary"> < Vissza a cikkekhez</router-link>
          </h5>
        </div>
      </div>
        <div class="row">
            <div class="col-lg-12 content-title mt-1 mb-3">
                <div class="col-lg-12 content-title mt-1 mb-3">
                    <h2 class="content-title">{{ post && post.id ? 'Cikk szerkesztése' : (loading ? 'Betöltés szerkesztésre...' : 'Új cikk') }}</h2>
                </div>
            </div>
        </div>
        <loader :loading="loading_status"></loader>
        <div class="row">
            <div class="col-lg-12 content-body" v-if="!loading_status && user.is_admin">
                <div class="post-info">
                    <div class="row justify-content-center">
                        <div class="col-lg-6 content-body uploader">
                            <div class="row">
                                <image-uploader :data="imageData"
                                                @onImageLoaded="onImageLoaded"
                                                @onImageRemoved="onImageRemoved"
                                                placeholder="Borítókép"
                                    />
                            </div>
                            <div class="row form-group mt-3">
                                <label class="control-label">A kép forrása</label>
                                <input type="text" class="form-control" v-if="post" v-model="post.thumbnail_source"/>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group" v-if="post">
                        <div class="col-sm-12">
                            <label class="control-label">Cím</label>
                            <input type="text" class="form-control" v-model="post.title" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.post.title.$error }"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4">
                            <label class="control-label">Kategória</label>
                            <b-form-select v-model="post.menu_id" class="form-control" :options="menu_list"
                                           :class="{ 'field-error' : this.$v.post.menu_id.$error }"></b-form-select>
                        </div>
                        <div class="col-sm-4">
                            <label class="control-label">Alkategória</label>
                            <b-form-select v-model="post.secondary_menu_id" class="form-control"
                                           :options="secondary_menu_list"
                                           ></b-form-select>
                        </div>
                        <div class="col-sm-4">
                            <label class="control-label">Típus</label>
                            <b-form-select v-model="post.post_type" class="form-control"
                                           :options="post_type_list"
                            ></b-form-select>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-12">
                            <label class="control-label">Rövid tartalom</label>
                            <textarea rows="5" class="form-control" v-model="post.short_content" autocomplete="off"
                                      :class="{ 'field-error' : this.$v.post.short_content.$error }"></textarea>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-12">
                            <label class="control-label">Tartalom</label>
                            <editor v-model="post.content"
                                    @onLoadContent="onLoadContent"
                                    api-key="3iw8m0vqjqlu99dvhgax6kyxmrmyw15lcmaei43c2pwlitni"
                                    :init="{
                                     height: 500,
                                     menubar: false,
                                     options: {
                                        language_url: '../../assets/js/tinymce/hu_HU.js' //This url points to location of persian language file.
                                    },
                                     plugins: [
                                       'advlist autolink lists link image charmap print preview anchor',
                                       'searchreplace visualblocks code fullscreen',
                                       'insertdatetime media table paste code help',
                                       'link image code preview imagetools',
                                     ],

                                     toolbar: [
                                       'undo redo | formatselect | bold italic backcolor | \
                                       alignleft aligncenter alignright alignjustify | \
                                       bullist numlist outdent indent | removeformat | help',
                                       'searchreplace visualblocks code fullscreen \
                                       | insertdatetime media table paste code help \
                                       | link image code preview imagetools | blockquote'
                                     ],
                                     content_style: 'body { font-size: 18px; }',
                                     image_advtab: true,

                                     image_title: true,
                                      /* enable automatic uploads of images represented by blob or data URIs*/
                                      automatic_uploads: false,
                                      /*
                                        URL of our upload handler (for more details check: https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_url)
                                        images_upload_url: 'postAcceptor.php',
                                        here we add custom filepicker only to Image dialog
                                      */
                                      images_upload_url: this.fileUploadURL,
                                      file_picker_types: 'image',
                                      file_picker_callback: this.fileUploaderCallback,

                                   }"
                                   ref="editor"/>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-6">
                            <label class="control-label">Kulcsszavak</label>
                            <vue-tags-input
                                    placeholder="Új kulcsszó"
                                    v-model="tag"
                                    :tags="tags"
                                    :autocomplete-items="filteredItems"
                                    @tags-changed="onTagsChanged"
                            />
                        </div>
                    </div>
                    <div class="row form-group pt-3" v-if="post && post.id">
                        <div class="col-sm-12">
                            <ShareNetwork
                                    network="facebook"
                                    :url="post_url"
                                    :title="post.title"
                                    :description="post.short_content"
                                    class="c-pointer">
                                <i class="fab fa-facebook-square text-primary sh-logo"></i> Megosztás a Facebook-on
                            </ShareNetwork>
                        </div>
                    </div>
                    <div class="row form-group" v-if="post && post.id">
                        <div class="col-sm-12">
                            <a :href="post_url" target="_blank">{{ post_url }}</a>
                        </div>
                    </div>
                </div>
                <div class="action-buttons pt-4">
                    <div class="row info mx-auto mb-5 form-group bg-success w-50" :class="{
                    'bg-danger': post.menu_type === 'draft',
                    'bg-success': post.menu_type === 'post',
                    }" v-if="post && post.id">
                        <i class="fas fa-info-circle"></i>
                        <span v-if="post.menu_type === 'draft'">Ez a cikk piszkozat {{ post.last_update }}!</span>
                        <span v-if="post.menu_type === 'post'">Ez a cikk közzé van téve - {{ post.last_update }}!</span>
                    </div>
                    <div class="row form-group">
                        <div class="col-lg-10 text-center mx-auto">
                            <div class="row">
                                <div class="col" v-if="postIsReady">
                                    <button class="btn btn-md btn-success"
                                            @click="saveDraft">Mentés piszkozatként</button>
                                </div>
                                <div class="col" v-if="postIsReady">
                                    <button class="btn btn-md btn-secondary"
                                            @click="preview">Előnézet</button>
                                </div>
                                <div class="col">
                                    <button class="btn btn-md btn-primary" @click="save('post')">Közzététel</button>
                                </div>
                                <div class="col" v-if="post.id">
                                    <button class="btn btn-md btn-primary btn-danger" @click="confirmDelete">Törlés</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </admin-layout>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import required from "vuelidate/src/validators/required";
    import Loader from '../../common/controls/Loader'
    import ImageUploader from "../../common/lib/fileUploader/ImageUploader";
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import VueTagsInput from '@johmun/vue-tags-input';
    import {decodeEntities, replaceAccents} from "../../helpers/methods";
    import AdminLayout from "../../AdminLayout";

    export default{
        name: 'post-details',
        data(){
            return{
                exitWithoutConfirm: true,
                initialPostState: {
                    menu_id: 1,
                    secondary_menu_id: 0,
                    post_type: '',
                    short_content: '',
                    content: '',
                },
                imageData: {},
                image_removed: false,
                fileUploadURL: axios.defaults.baseURL+'/api/image-upload/post-content',
                site_url: process.env.VUE_APP_API_URL,
                autosave_interval_sec: process.env.VUE_APP_AUTOSAVE_INTERVAL_SEC ? process.env.VUE_APP_AUTOSAVE_INTERVAL_SEC: 60,
                tag: '',
                tags: [],
                autocompleteItems: [],
                post: this.postDetails ? this.postDetails : {
                  menu_id: 1,
                  secondary_menu_id: 0,
                  content: '',
                  thumbnail_source: '',
                },
            }
        },
        components: {
            Loader,
            ImageUploader,
            'editor': Editor,
            VueTagsInput,
            AdminLayout
        },
        computed: {
            ...mapGetters([
                'postDetails',
                'loading',
                'postTypes',
                'user',
                'userID',
                'mostUsedKeywords',
            ]),
          menuItems(){
            return this.$store.getters['getMenuItems'];
          },
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            app_url() {
                return window.location.protocol+'//'+window.location.host;
            },
            post_url() {
                return this.app_url+this.post.post_url;
            },
            menu_list() {
                let list = [

                ];
                if(this.menuItems) {
                    this.menuItems.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.name
                        });
                    });
                }

                return list;
            },
            secondary_menu_list() {
                let list = [
                    { value: 0, text: '-Válasszon-' }
                ];

                if(this.submenuList) {
                    this.submenuList.map((item) => {
                        list.push({
                            value: item.id,
                            text: item.title
                        });
                    });
                }

                return list;
            },
            post_type_list() {
                let list = [
                    { value: '', text: '-Nincs megadva-' }
                ];
                if(this.postTypes) {
                    this.postTypes.map((item) => {
                        list.push({
                            value: item.name,
                            text: item.name
                        });
                    });
                }

                return list;
            },
            postIsReady() {
                let ready = this.post.title &&
                    this.post.short_content &&
                    this.post.content &&
                    (this.post.image || this.post.thumbnail);

                return ready;
            },
            filteredItems() {
                return this.autocompleteItems.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
        methods: {
            ...mapActions([
                'addPost',
                'updatePost',
                'deletePost',
                'getMenuItems',
                //'getSubmenus',
                'getPostTypes',
                'getMostUsedKeywords'
            ]),
            getPost() {
                let vm = this;
                if(parseInt(this.$route.params.id) > 0) {
                    this.$store.dispatch('getPostByID', {
                        id: this.$route.params.id
                    }).then((response) => {
                        if(response === null || ( response.data.is_active === 0 )) {
                            this.exitWithoutConfirm = true;
                            this.$store.commit('setErrorMessage', '#'+this.$route.params.id+' cikk nem létezik!');

                            this.$router.push({
                                name: '/a/posts',
                            });
                        } else {
                            if(response.data.content) {
                                setTimeout(function(){
                                    vm.setCharCount(vm.getCharsCount(response.data.content));
                                }, 1500);
                            }

                            this.addPostTags();
                        }
                    });
                } else {
                    this.post = this.postDetails;
                }
            },
            setPostDetails(data) {
                this.$store.commit('setPostDetails', data);
            },
            save(type) {
                let vm = this;
                this.$v.post.$touch();
                console.log('post $v', this.$v.post);

                if(!this.$v.post.$invalid) {
                    this.post.user_id = this.userID;
                    this.post.menu_type = type;

                    if(this.post.thumbnail) {
                        this.post.thumbnail = this.post.thumbnail.replace(this.site_url+'/images', '');

                        if(this.post.thumbnail.indexOf('/uploads') > -1 ) {
                            let spl = this.post.thumbnail.split('/uploads');

                            if(spl && spl.length > 1) {
                                this.post.thumbnail = '/uploads/'+spl[1];
                            }
                        }
                    }

                    if(this.post.image || this.post.thumbnail) {
                        if (this.post.id) {
                            this.updatePost(this.post, {}).then((response) => {

                            });
                        } else {
                            this.addPost(this.post, {}).then((response) => {
                                if(response.id > 0) {
                                    vm.$router.push({
                                        path: '/a/posts/' + response.id,
                                    });
                                    window.location.reload();
                                }
                            });
                        }
                    } else {
                        this.$store.commit('setErrorMessage', 'Tötlse fel a borítóképet!');
                    }

                } else {
                    this.$store.commit('setErrorMessage', 'Töltse ki a megjelölt mezőket!');
                }
            },
            saveDraft() {
                this.save('draft');
            },
            preview() {
                this.save('draft');
                let menu = this.menuList.find(m => m.id == this.post.menu_id);

                if(menu) {
                    window.open(this.site_url+'/'+menu.path+'/'+this.post.shortname+'?d=1', '_blank');
                }
            },
            autoSave() {
                /*
                if(this.postIsReady && (!this.post.id ||
                    this.post.menu_type == 'draft' ||
                    this.post.menu_type == 'auto-draft'
                ) && (this.$route.path.toString().indexOf('posts/add') > -1
                || this.$route.path.toString().indexOf('posts/'+this.post.id) > -1 ) ) {
                    this.save('auto-draft');
                }*/
            },
            autoSaveTrigger(){
                /*
                let vm = this;
                setTimeout(() => {
                    setInterval(function(){
                        vm.autoSave();
                    }.bind(this), vm.autosave_interval_sec * 1000);
                }, vm.autosave_interval_sec * 1000);
                */
            },
            confirmDelete() {
                let vm = this;
                this.exitWithoutConfirm = true;
                this.$dialog.confirm('Tényleg szeretné törölni a "'+this.post.title+'" cikket?', {})
                    .then((dialog) => {
                        vm.deletePost({
                            id: vm.post.id,
                        }).then((response) => {
                            this.$router.push({
                                name: 'posts',
                            });
                            dialog.close();
                        });
                    });
            },
            confirmExit(next) {
                if(!this.exitWithoutConfirm) {
                    let vm = this;
                    this.$dialog.confirm('Tényleg ki szeretne lépni a szerkesztőből?', {})
                        .then((dialog) => {
                            dialog.close();
                            next();
                        });
                }
            },
            clientNav(id) {
                window.location.href= '/posts/'+id;
            },
            onImageLoaded(imageObject) {
                this.$emit('onImageLoaded', imageObject);
                this.$set(this.post, 'image', imageObject);
                this.image_removed = false;
            },
            onImageRemoved() {
                this.image_removed = true;
            },
            getCharsCount(str) {
                if(str && str.length > 0) {
                    return replaceAccents(
                        decodeEntities(str)
                    ).length;
                }

                return 0;
            },
            setCharCount(count) {
                $('.tox-statusbar__path').html('Karaterszám: '+count);
            },
            onLoadContent() {
                if(this.post.content) {
                    this.setCharCount(this.getCharsCount(this.post.content));
                }
            },
            fileUploaderCallback(cb, value, meta) {
                var input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');

                input.onchange = function () {
                    var file = this.files[0];

                    var reader = new FileReader();
                    reader.onload = function () {
                        /*
                        Note: Now we need to register the blob in TinyMCEs image blob
                        registry. In the next release this part hopefully won't be
                        necessary, as we are looking to handle it internally.
                        */
                        var id = 'blobid' + (new Date()).getTime();
                        var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);

                        /* call the callback and populate the Title field with the file name */
                        cb(blobInfo.blobUri(), { title: file.name });
                    };
                    reader.readAsDataURL(file);
                };

                input.click();
            },
            onTagsChanged(newTags) {
                this.tags = newTags;
                this.post.keywords = newTags.map((item) => {
                    return item.text;
                }).join();
            },
            addPostTags() {
                let vm = this;
                if(this.post && this.post.keywords) {
                    let kws = this.post.keywords.split(',');

                    if(kws) {
                        kws.map((item) => {
                            vm.tags.push({
                                text: item.toString().trim(),
                            });
                        })
                    }
                }
            }
        },
        mounted() {
            this.setPostDetails(
                this.initialPostState,
            );
            this.setCharCount(0);
            this.getMenuItems();
            this.getPostTypes();
            this.getPost();

            this.autoSaveTrigger();
        },
        beforeRouteLeave(to, from, next) {

            if(this.exitWithoutConfirm) {
                next();
            } else {
                this.confirmExit(next);
            }
            this.tags = [];

            this.setPostDetails(
                this.initialPostState,
            );

            this.post = this.initialPostState;
            this.post.short_content = "";
            this.post.content = "";
            this.post.title = "";
            this.post.thumbnail_source = "";
        },
        beforeRouteUpdate (to, from, next) {
            if(from.params.id && to.params.id == 'add') {
                this.confirmExit(next);
            } else {
                next();
            }
        },
        destroyed() {
            this.setPostDetails(
                this.initialPostState,
            );
        },
        watch: {
            postDetails: {
                handler:  function(newVal) {

                  if(newVal && newVal.data) {
                    this.post = newVal.data;

                    if(this.post) {
                      if(this.post.thumbnail) {
                        this.$set(this.imageData, 'image', this.post.thumbnail);
                      }

                      if(this.post.content) {
                        this.setCharCount(this.getCharsCount(this.post.content));
                      }

                      if(this.post.menu_id) {
                        let menu = this.menuItems.find(m => m.id === this.post.menu_id);
                        if(menu) {
                          this.getMostUsedKeywords({
                            menu_path: menu.path,
                          });

                          /*
                          this.getSubmenus({
                              parent_id: newVal.menu_id,
                          });*/
                        }
                      }
                    }
                  }
                },
                deep: true,
            },
            '$route': {
                handler: function(newVal) {
                    if(newVal.params.id == 'add') {
                        this.imageData = {};
                        this.setPostDetails(
                            this.initialPostState,
                        );
                    }
                },
                deep: true,
            },
            mostUsedKeywords: function(newVal) {
                let vm = this;
                this.autocompleteItems = [];
                newVal.map((item) => {
                    vm.autocompleteItems.push({
                        text: item.toString().trim(),
                    });
                });
            }

        },
        validations() {
            let vm = this;

            return {
                post: {
                    title: {
                        required,
                    },
                    menu_id: {
                        required,
                    },
                    short_content: {
                        required,
                    },
                    content: {
                        required,
                    }
                }
            }
        },
    }
</script>

<style scoped="" lang="scss">
    button{
        padding-bottom: 7px;
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }

    .action-buttons {
        .info {
            padding: 15px;
            font-size: 18px;
            color: white;

            svg {
                position: relative;
                top: 4px;
                right: 5px;
            }
        }
    }
    .modules {
        a {
            color: #3d5170;
        }

        a:hover{
            text-decoration: none;
            color: #007bff;
        }

        ul{
            list-style: none;
            li {

            }
        }
        label {
            input {
                margin-right: 5px;
            }
        }
    }
    .uploader {
        border-top: 2px #dc3545 solid;
        box-shadow: none;
        padding: 30px !important;
        margin-top: 20px;
    }
    .sh-logo {
        font-size: 19px;
    }

    input, textarea, select, label {
        font-size: 18px;
    }
</style>
